export const CONFIG = {
  "PROJECTNAME": "aksazeytin",
  "COMPANYNAME": "Aksa Zeytin",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10001122",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#c2002f",
    "primary100": "rgba(194, 0, 47, 0.1)",
    "light": "#c2002f",
    "secondary": "#c2002f",
    "dark": "#c2002f",
    "siteColor3": "#fff",
    "menuSecondary": "#c2002f"
  }
};